import { HttpOptions } from "@apollo/client";

export const httpLinkOptions: HttpOptions = {
    uri: "https://api.nexusmods.com/v2/graphql",
};
export default httpLinkOptions;
